document.addEventListener("DOMContentLoaded", () => {
    const isLoggedIn = !!ShopifyAnalytics.meta.page.customerId;

    // Helper function to decode HTML entities
    function decodeHtmlEntities(text) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, "text/html");
        return doc.documentElement.textContent;
    }

    function fetchDigitalDownloads(currentPage) {
        setLocalStorage('hasOrderHistoryProductsSynced', 'false');

        const baseUrl = '/apps/digital-downloads/orders/?page=';
        const items = JSON.parse(getLocalStorage('orderHistoryProducts', '[]'));

        fetch(baseUrl + currentPage)
            .then(response => response.text())
            .then(responseText => {
                const parsedResponse = new DOMParser().parseFromString(responseText, "text/html")
                const paginationButton = parsedResponse.querySelector(".dda-orders__pagination");

                // Gather all orders from the response and append them to the existing list of orders
                Array.from(parsedResponse.querySelectorAll('.dda-orders__list .dda-order'))
                    .forEach(order => {
                        const titles = order.querySelectorAll('h3.dda-order__item-name');
                        const filenames = order.querySelectorAll('.dda-order__asset-filename > span');

                        // Prepare text content for localStorage
                        titles.forEach(title => items.push(title.textContent));
                        filenames.forEach(filename => items.push(
                                filename.textContent
                                    .replace('.zip', '')
                                    .replace('.wav', '')
                            )
                        );

                        setLocalStorage('orderHistoryProducts', JSON.stringify(items));
                    });

                // If more pagination is available, fetch another page and continue the loop
                if (paginationButton) {
                    const currentPageInt = parseInt(currentPage);

                    setLocalStorage('orderHistoryProductsCurrentPage', currentPageInt + 1);
                    fetchDigitalDownloads(currentPageInt + 1);
                } else {
                    // Wrap up the results
                    setLocalStorage('hasOrderHistoryProductsSynced', 'true');

                    // the Set part here is so our array is unique
                    setLocalStorage('orderHistoryProducts', JSON.stringify([...new Set(items)]));
                }
            });
    }

    function getLocalStorage(key, defaultValue) {
        return localStorage.getItem(key) || defaultValue;
    }

    function setLocalStorage(key, value) {
        localStorage.setItem(key, value);
    }

    /**
     * ORDER HISTORY PRODUCTS
     *
     * Fetch digital downloads if they haven't been synced yet
     */
    if (isLoggedIn && getLocalStorage('hasOrderHistoryProductsSynced', 'false') === 'false') {
        fetchDigitalDownloads(getLocalStorage('orderHistoryProductsCurrentPage', '1'));
    }

    // Reset all the storage data upon logging out
    if (!isLoggedIn && window.location.href === 'https://ovanisound.com/') {
        setLocalStorage('hasOrderHistoryProductsSynced', 'false');
        setLocalStorage('orderHistoryProducts', JSON.stringify([]));
        setLocalStorage('orderHistoryProductsCurrentPage', '1');
    }

    if (window.location.href.includes("/apps/digital-downloads/")) {
        // Scan library, add to local storage, remove duplicates from cart
        fetch("/cart.js")
            .then(response => response.json())
            .then(cart => {
                // Get all order products
                const h3Elements = document.querySelectorAll("h3.dda-order__item-name");
                const libraryAssets = document.querySelectorAll(".dda-order__asset-filename");

                // Get array of owned products
                let orderHistoryProducts = JSON.parse(localStorage.getItem('orderHistoryProducts')) || [];

                libraryAssets.forEach(libraryAsset => {
                    const assetTitle = libraryAsset.querySelector("span").innerHTML;
                    const assetName = decodeHtmlEntities(assetTitle.replace(".zip", ""));

                    // Add the product title to localStorage if it is not already stored
                    if (!orderHistoryProducts.includes(assetName)) {
                        orderHistoryProducts.push(assetName);
                    }
                });

                h3Elements.forEach(h3 => {
                    const productName = decodeHtmlEntities(h3.textContent.trim());

                    // Add the product title to localStorage if it is not already stored
                    if (!orderHistoryProducts.includes(productName)) {
                        orderHistoryProducts.push(productName);
                    }

                    // Store the updated product titles back to localStorage
                    localStorage.setItem('orderHistoryProducts', JSON.stringify(orderHistoryProducts));

                    // Check if product title matches a product in the cart
                    const matchingItem = cart.items.find(item => 
                        decodeHtmlEntities(item.title.trim()).toLowerCase() === productName.toLowerCase()
                    );

                    if (matchingItem) {
                        if (confirm(`You already own product "${productName}"! Remove it from the cart?`)) {
                            fetch("/cart/change.js", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({
                                    id: matchingItem.key, // Use the line item ID
                                    quantity: 0
                                })
                            })
                                .then(response => {
                                    if (!response.ok) {
                                        throw new Error(`Error: ${response.statusText}`);
                                    }
                                    return response.json();
                                })
                                .then(updatedCart => {
                                    alert(`"${productName}" has been removed from your cart.`);
                                    window.location.reload(); // Reloads the page
                                })
                                .catch(error => {
                                    console.error("Error removing item from cart:", error);
                                    alert("There was an issue removing the product from your cart. Please try again.");
                                });
                        }
                    }
                });
            })
            .catch(error => {
                console.error("Error fetching cart:", error);
            });
    } else {
        const PDPTitle = decodeHtmlEntities(document.querySelector("#product-title")?.textContent.trim());
        const cards = document.querySelectorAll(".product-card-wrapper");

        // Get the list of products from the order history stored in localStorage
        const orderHistoryProducts = JSON.parse(localStorage.getItem('orderHistoryProducts')) || [];

        // Check if the current product title is in the order history
        if (PDPTitle && orderHistoryProducts.includes(PDPTitle)) {
            // Find the product form and replace it with a Download button
            const productReminder = document.querySelector("#product-template__download-reminder");
            const productForm = document.querySelector("#form-container");
            const form = productForm.querySelector("form");
            const downloadCTA = productForm.querySelector(".download-library-link");

            if (form) form.style.display = 'none';
            if (productReminder) productReminder.style.display = 'none';
            if (downloadCTA) downloadCTA.style.display = 'block';

        } else {
            const productInfo = document.querySelector("product-info");
            if (productInfo) {
                const productContents = productInfo.dataset.bundleContents;
                if (productContents) {
                    // Parse productContents into an array
                    const bundleProducts = productContents.split(',').map(item => decodeHtmlEntities(item.trim()));
                    const matchingProducts = bundleProducts.filter(product =>
                        orderHistoryProducts.includes(product)
                    );

                    if (matchingProducts.length > 0) {
                        const partiallyOwned = document.querySelector('#product-template__partially_owned');
                        if (partiallyOwned) partiallyOwned.style.display = 'block';
                    }
                }
            }
        }

        function normalizeTitle(title) {
            return title
                .replace(/:/g, '') // Remove colons
                .replace(/\bVol\. 1\b/gi, '') // Remove "Vol. 1" only
                .replace(/&amp;/gi, '&') // Replace HTML entity &amp; with &
                .replace(/\s+/g, ' ')
                .trim() 
                .toLowerCase();
        }
        
        if (cards) {
            cards.forEach(card => {
                const cardTitle = card.querySelector(".product-card-title");
                const productTitle = decodeHtmlEntities(cardTitle.textContent.trim());
                const productFilename = decodeHtmlEntities(card.dataset.filename || "");
        
                const normalizedProductTitle = normalizeTitle(productTitle);
                const normalizedOrderHistoryProducts = orderHistoryProducts.map(normalizeTitle);
        
        
                if (
                    productTitle &&
                    normalizedOrderHistoryProducts.includes(normalizedProductTitle)
                ) {
                    const checkmark = card.querySelector(".product-owned-checkmark");
                    if (checkmark) checkmark.style.display = 'block';
                } else if (orderHistoryProducts.includes(productFilename)) {
                    const checkmark = card.querySelector(".product-owned-checkmark");
                    if (checkmark) checkmark.style.display = 'block';
                } else {
                    const bundleContents = card.dataset.bundleContents;
                    if (bundleContents) {
                        // Parse bundleContents into an array
                        const bundleProducts = bundleContents.split(',').map(item => normalizeTitle(decodeHtmlEntities(item.trim())));
                        const matchingProducts = bundleProducts.filter(product =>
                            normalizedOrderHistoryProducts.includes(product)
                        );
        
                        if (matchingProducts.length > 0) {
                            const partialCheckmark = card.querySelector(".product-partially-owned-checkmark");
                            if (partialCheckmark) partialCheckmark.style.display = 'block';
                        }
                    }
                }
            });
        }

    }
});
